const appLocales = {
  PT_BR: 'pt-Br',
  EN: 'en',
  ES: 'ES'
};

export default appLocales;